import { createContext, useContext, useState, useEffect } from 'react'
import { authApi, adminUsersApi } from '../api/client'

const AuthContext = createContext(null)

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const token = localStorage.getItem('jwt_token')
    if (token) {
      adminUsersApi.me()
        .then(res => setUser(res.data))
        .catch(() => localStorage.removeItem('jwt_token'))
        .finally(() => setLoading(false))
    } else {
      setLoading(false)
    }
  }, [])

  const login = async (email, password) => {
    const res = await authApi.login(email, password)
    localStorage.setItem('jwt_token', res.data.token)
    const me = await adminUsersApi.me()
    setUser(me.data)
    return me.data
  }

  const logout = () => {
    localStorage.removeItem('jwt_token')
    setUser(null)
  }

  return (
    <AuthContext.Provider value={{ user, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  )
}

export function useAuth() {
  return useContext(AuthContext)
}
